<template>
  <v-toolbar flat app color="purple lighten-1 white--text">
    <v-toolbar-title router:to="/" class="white--text"
      >株式会社happiness</v-toolbar-title
    >
    <!-- <v-spacer></v-spacer>
    <v-toolbar-items class="hidden-sm-and-down white--text">
      <v-btn flat router:to="#service" class="white--text"
        >事業・サービス</v-btn
      >
      <v-btn flat router:to="#app" class="white--text"
        >内田騎乗依頼アプリ</v-btn
      >
      <v-btn flat class="white--text">会社概要</v-btn>
      <v-btn flat class="white--text">お問い合わせ</v-btn>
    </v-toolbar-items> -->
  </v-toolbar>
</template>

<script>
export default {};
</script>

<style></style>
